// Panels the player can move around within the window. Only the grip starts a drag, so
// buttons, inputs and cards inside the panel keep working normally.
import { motion, useDragControls } from "framer-motion";
import { createContext, useContext, type ReactNode } from "react";

import css from "./Unfathomable.module.css";

/** The full-window element panels are kept inside. */
export const DragBoundsCtx = createContext<React.RefObject<HTMLElement> | null>(null);

export function DragPanel({ children, className, style }: { children: ReactNode; className?: string; style?: React.CSSProperties }) {
  const bounds = useContext(DragBoundsCtx);
  const controls = useDragControls();
  return (
    <motion.div className={`${css.dragPanel} ${className ?? ""}`} style={style}
      drag dragControls={controls} dragListener={false} dragMomentum={false} dragElastic={0}
      dragConstraints={bounds ?? undefined}>
      <div className={css.dragGrip} title="按住拖动面板" onPointerDown={e => controls.start(e)}>⠿</div>
      {children}
    </motion.div>
  );
}
